import { render, staticRenderFns } from "./ShowTransaction.vue?vue&type=template&id=0d64d0b5&scoped=true"
import script from "./ShowTransaction.vue?vue&type=script&lang=js"
export * from "./ShowTransaction.vue?vue&type=script&lang=js"
import style0 from "./ShowTransaction.vue?vue&type=style&index=0&id=0d64d0b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d64d0b5",
  null
  
)

export default component.exports